import { render } from "./CreateBASTProxy.vue?vue&type=template&id=0c032be8&scoped=true"
import script from "./CreateBASTProxy.vue?vue&type=script&lang=js"
export * from "./CreateBASTProxy.vue?vue&type=script&lang=js"

import "./CreateBASTProxy.vue?vue&type=style&index=0&id=0c032be8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c032be8"]])

export default __exports__